import request from '@/utils/request'

export function updateLocalPushCfg(data) {
  return request({
    url: 'api/v1/local-push/updateCfg',
    method: 'post',
    data: data
  })
}

export function getLocalPushCfg(data) {
  return request({
    url: 'api/v1/local-push/getCfg',
    method: 'post',
    data: data
  })
}

export function getLocalPushType(data) {
  return request({
    url: 'api/v1/local-push/getType',
    method: 'post',
    data: data
  })
}

export function localPushAsycnS3() {
  return request({
    url: 'api/v1/local-push/ayncS3',
    method: 'post'
  })
}

export function getLocalPushAllCfg() {
  return request({
    url: 'api/v1/local-push/getAllCfg',
    method: 'get'
  })
}
export function delLocalPushCfg(data) {
  return request({
    url: 'api/v1/local-push/deleteCfg',
    method: 'delete',
    data: data
  })
}

export function importLocalPushCfg(data) {
  return request({
    url: 'api/v1/local-push/importCfg',
    method: 'post',
    data: data
  })
}
export function exportLocalPushCfg(data) {
  return request({
    url: 'api/v1/local-push/exportCfg',
    method: 'post',
    data: data
  })
}

